import { render, staticRenderFns } from "./ProfileDialog.vue?vue&type=template&id=3d008efc&scoped=true"
import script from "./ProfileDialog.vue?vue&type=script&lang=js"
export * from "./ProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./ProfileDialog.vue?vue&type=style&index=0&id=3d008efc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d008efc",
  null
  
)

export default component.exports